module.exports = {"baseUrl":"https://api.aircheckr.com","demoApiUrl":"https://api.aircheckr.com","token":"eyJhbGciOiJIUzI1NiJ9.OTM2YzU4NTAtZWExYS0xMWU3LWJlZmItM2I2YTI2MTMxZGE0.H__gU65mXz2qJAx1yw2AdkeRiyxHo_KVW2caxbICcOk"};


// WEBPACK FOOTER //
// external "{/"baseUrl/":/"https:/api.aircheckr.com/",/"demoApiUrl/":/"https:/api.aircheckr.com/",/"token/":/"eyJhbGciOiJIUzI1NiJ9.OTM2YzU4NTAtZWExYS0xMWU3LWJlZmItM2I2YTI2MTMxZGE0.H__gU65mXz2qJAx1yw2AdkeRiyxHo_KVW2caxbICcOk/"}"